// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"128f81cf","380":"16885e8b","382":"932f38e2","418":"83ab18e0","573":"0ee96e6e","791":"f29d802a"}[chunkId] + ".chunk.js";
};